import { render, staticRenderFns } from "./CalendarDetailDropdownCustomText.vue?vue&type=template&id=0976d296&"
import script from "./CalendarDetailDropdownCustomText.vue?vue&type=script&lang=js&"
export * from "./CalendarDetailDropdownCustomText.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDetailDropdownCustomText.vue?vue&type=style&index=0&id=0976d296&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports